import { compose, equals, filter } from 'ramda';

/**
 * Returns the status of a participant
 *
 * @param participant
 */
const getStatus = (participant) => participant.status;

/**
 * Checks if a participant is checked in
 *
 * @param participant
 */
const isCheckedIn = compose(equals("checkedIn"), getStatus);

/**
 * Gets all participants that are checkedIn/playing
 *
 * @param participant
 */
const getCheckedIn = filter(isCheckedIn);

/**
 * Generated bundle index. Do not edit.
 */

export { getCheckedIn, getStatus, isCheckedIn };
//# sourceMappingURL=play-utility-participant.js.map
